module.exports = __webpack_public_path__ + "static/media/mom_alone.48f0b8ee.jpg";